import { useCallback, useState } from 'react';

import { initialErrorState } from 'features/payment/initial-state';
import { isGiftCardNumberValid } from 'features/payment/utils';
import { useIntl } from 'react-intl';

import { sanitizeNumber } from 'utils/form';

const isValidGiftCardNumberCheck = (newGiftCardNumber: string) =>
  isGiftCardNumberValid(sanitizeNumber(newGiftCardNumber));

export const useCardNumber = () => {
  const { formatMessage } = useIntl();
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [errors, setErrors] = useState(initialErrorState);
  const [isValidGiftCardNumber, setIsValidGiftCardNumber] = useState(false);

  const validateCardNumber = useCallback(
    (newGiftCardNumber: any) => {
      const isValid = isValidGiftCardNumberCheck(newGiftCardNumber);
      let giftCardNumberErrorMessage: string | undefined;
      if (!isValid) {
        giftCardNumberErrorMessage = newGiftCardNumber
          ? formatMessage({ id: 'giftCardNumberIsNotValid' })
          : formatMessage({ id: 'giftCardNumberIsRequired' });
      }
      setErrors(prevState => {
        return {
          ...prevState,
          giftCardNumber: giftCardNumberErrorMessage,
        };
      });
      setIsValidGiftCardNumber(isValid);
    },
    [formatMessage]
  );

  const handleCardNumberChange = useCallback(
    (newGiftCardNumber: any) => {
      const formattedNumber = sanitizeNumber(newGiftCardNumber);
      setGiftCardNumber(formattedNumber);

      validateCardNumber(formattedNumber);
    },
    [validateCardNumber]
  );

  return {
    giftCardNumber,
    errors,
    isValidGiftCardNumber,
    handleCardNumberChange,
    isValidGiftCardNumberCheck,
    validateCardNumber,
  };
};
